<template>
    <LayoutDefault variant="white">
        <div class="legacy">
            <TransitionFade>
                <div v-if="!loaders['GET_EVENT_' + id]">
                    <!-- header -->
                    <OrganismPageHeader light :background-image="event.cropped_cover ? '/storage/' + event.cropped_cover : event.cover.cached_full_url" />

                    <main class="main-container detail-page">


                        <!-- title -->
                        <Title
                            :title="event.name"
                            :types="event.types"
                            :subcategories="event.subcategories"
                            :labels="event.labels"
                            :color-label="colorLabels"
                            :color-subcategory="colorSubcategories"
                        />

                        <Information :event="event"/>

                        <Description v-if="event.description" :description="event.description"/>

                        <images-slider v-if="images && images.length"
                                       :images="images"
                        />

                        <video-slider v-if="event.videos && event.videos.length" :videos="event.videos"/>

                        <people-list v-if="event.people && event.people.length" :people="event.people"/>

                        <linked-event v-if="event.linked_events && event.linked_events[0] != null"
                                      :events="event"></linked-event>

                        <detailed-info :data="event"/>

                        <tags-item v-if="event.labels || event.subcategories"
                                   :subcategories="event.subcategories"
                                   :labels="event.labels"
                                   :color-label="colorLabels"
                                   :color-subcategory="colorSubcategories"/>
                    </main>

                </div>
            </TransitionFade>
        </div>
        <AtomFullPageLoader v-if="loaders['GET_EVENT_' + id]" />
    </LayoutDefault>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import Header from '../components/legacy/PageDetail/Header'
import Title from '../components/legacy/PageDetail/Title';
import Information from '../components/legacy/PageDetail/Information'
import LinkedEvent from '../components/legacy/PageDetail/LinkedEvent';
import ImagesSlider from '../components/legacy/PageDetail/ImagesSlider';
import Description from '../components/legacy/PageDetail/Description';
import DetailedInfo from '../components/legacy/PageDetail/DetailedInfo';
import PeopleList from '../components/legacy/PageDetail/PeopleList';
import prependHttp from "prepend-http";
import VideoSlider from '../components/legacy/PageDetail/VideoSlider';
import TagsItem from '../components/legacy/PageDetail/TagsItem';
import Separator from '../components/legacy/PageDetail/Separator';
import DarkMode from '../mixins/dark-mode';
import Reset from '../mixins/reset';
import HeadTitle from '../components/legacy/Divers/HeadTitle';
import Spinner from '../components/legacy/Divers/Spinner';
import TransitionFade from "../transitions/TransitionFade.vue";
import OrganismPageHeader from "../components/global/organisms/OrganismPageHeader.vue";
import LayoutDefault from "../layouts/LayoutDefault.vue";
import AtomFullPageLoader from "../components/global/atoms/AtomFullPageLoader.vue";

export default {
    name: 'PageEvent',
    mixins: [DarkMode, Reset],
    components: {
        AtomFullPageLoader,
        LayoutDefault,
        OrganismPageHeader,
        TransitionFade,
        Spinner,
        Header,
        HeadTitle,
        Separator,
        Title,
        Information,
        LinkedEvent,
        ImagesSlider,
        Description,
        PeopleList,
        VideoSlider,
        TagsItem,
        DetailedInfo
    },
    created() {
        this.getEvent(this.id)
        this.getAllColors().then(() => {
            this.colorLabels = this.getColorForModel('label')
            this.colorSubcategories = this.getColorForModel('subcategory')
        })

    },
    data: () => {
        return {
            colorSubcategories: null,
            colorLabels: null
        }
    },
    props: {
        id: {
            required: true
        }
    },
    methods: {
        ...mapActions('event', [
            'getEvent'
        ]),
        ...mapActions('color', [
            'getAllColors'
        ]),
        addHttp(url) {
            if (url) {
                return prependHttp(url);
            }
        }
    },
    computed: {
        ...mapState('event', {
            event: state => state.selectedEvent ?? {id: 0}
        }),
        ...mapState('ui', [
            'loaders'
        ]),
        ...mapGetters('event', {
            images: 'getAllSelectedEventImages',
            cover: 'getEventCover',
            thumbnail: 'getEventThumbnail'
        }),
        ...mapGetters('color', [
            'getColorForModel'
        ])
    },
    watch: {
        id(newId, oldId) {
            if (newId !== oldId) {
                this.getEvent(this.id)
            }
        }
    },
}
</script>

<style scoped>

</style>
